export const environment = {
	production: true,
	baseUrl: "https://api.medinthepocket.com",
	// eslint-disable-next-line @typescript-eslint/no-require-imports
	appVersion: require("../../package.json").version,
	firebaseConfig: {
		apiKey: "AIzaSyDQ91ArHaJvyiGwW9BsGV2AuPPwDaLyAJ4",
		authDomain: "medinthepocket.firebaseapp.com",
		projectId: "medinthepocket",
		storageBucket: "medinthepocket.appspot.com",
		messagingSenderId: "8463853957",
		appId: "1:8463853957:web:8bc641a30432996d9d7cec",
		measurementId: "G-PXWXC80YJP",
		vapidKey: "BJfOu7nHa4yzw3nIR4pl2YvoNfvq9oSSpXRuDTWpWsZMb4PvSlzex-KC0az-dwp80XfyS1wACKF2UcWy1cC1fCM",
	},
	tolgeeApiUrl: "",
	tolgeeApiKey: "",
	muxDataEnvKey: "k31d732kuf8kn06shdplj79lv",
};
